import video from './video';
import links from './links';
import base from './base';

export default {
    video,
    links,
    base,
};
